import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { EASE, GoldButton, OutlineButton } from "@/components/Reveal";

export default function ThankYouPage() {
  const { state } = useLocation();
  const name = state && state.name ? state.name.split(" ")[0] : "";

  return (
    <section className="flex min-h-[100svh] items-center justify-center bg-navy-800 px-5 pt-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-xl text-center"
        data-testid="thank-you-panel"
      >
        <CheckCircle2 className="mx-auto h-16 w-16 text-gold" />
        <h1 className="mt-8 font-serif text-5xl font-medium text-ivory sm:text-6xl">
          Thank you{name ? `, ${name}` : ""}
        </h1>
        <p className="mt-6 text-sm font-light leading-relaxed text-mist sm:text-base">
          Your enquiry is on its way across Clew Bay. We'll be in touch shortly to build your
          perfect island adventure. If you need us sooner, call +353 86 251 8252 or email
          info@theadventureislands.com.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <GoldButton href="/" testId="thankyou-home">Back to Home</GoldButton>
          <OutlineButton href="/experiences" testId="thankyou-experiences">Explore Experiences</OutlineButton>
        </div>
      </motion.div>
    </section>
  );
}
